import { render, staticRenderFns } from "./DrivingLicenseFormDetail.vue?vue&type=template&id=56eb56e8&"
import script from "./DrivingLicenseFormDetail.vue?vue&type=script&lang=js&"
export * from "./DrivingLicenseFormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports